import { Box } from 'components/common/Box';
import { Typography } from 'components/common/Typography';
import styled, { keyframes } from 'styled-components';
import { COLORS } from 'theme/colors';
import { SIZES } from 'theme/sizes';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-70px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-70px);
  }
`;

type StyledFixedHeaderContainerProps = {
  showFixedHeader: boolean;
};

export const StyledFixedHeaderContainer = styled(
  Box,
)<StyledFixedHeaderContainerProps>`
  position: fixed;
  top: 0;
  z-index: 1;

  background-color: ${COLORS.background.secondary};
  width: 100%;

  animation: ${({ showFixedHeader }) => (showFixedHeader ? fadeIn : fadeOut)}
    0.5s ease-in-out;
`;

export const StyledContainer = styled(Box)`
  background-color: ${COLORS.background.module};
`;

export const StyledTopContainer = styled(Box)`
  padding-top: ${SIZES.spacing(2.5)};
  padding-bottom: ${SIZES.spacing(4)};

  ${SIZES.media.tablet} {
    padding-top: ${SIZES.spacing(9.4)};
    padding-bottom: ${SIZES.spacing(4.7)};
  }
`;

export const StyledHeader = styled(Typography)`
  font-size: 32px;
  line-height: 46px;

  ${SIZES.media.tablet} {
    font-size: 64px;
    line-height: 57px;
  }
`;

export const StyledSubHeader = styled(Typography)`
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.typography.description};
  text-align: center;
  margin-top: 24px;
  width: 92%;

  ${SIZES.media.tablet} {
    font-size: 18px;
    line-height: 26px;
    width: 65%;
  }

  ${SIZES.media.desktop} {
    width: 45%;
  }
`;

export const StyledFormContainer = styled(Box)`
  margin: 0 auto;
  padding: 0 ${SIZES.spacing(2.5)} ${SIZES.spacing(8)};

  ${SIZES.media.phone} {
    width: 90%;
  }

  ${SIZES.media.desktop} {
    width: 45%;
    padding: 0 0 ${SIZES.spacing(25)} 0;
  }
`;
